<template>
  <div id="connection-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
          <vs-input :disabled="true" class="w-full mt-4" label="Nome da conta" v-model="data_local.name" v-validate="'required'" name="name" />
          <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
          <vs-input :disabled="true" class="w-full mt-4" label="Celular do administrador" v-model="data_local.phone" v-validate="'required'" v-mask="'(##) #####-####'" name="phone" />
          <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
          <vs-input :disabled="true" class="w-full mt-4" label="Email do administrador" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          <div>
            <p class="selectLabel">Tipo da conta</p>
            <v-select :disabled="!enableFullUpdate" :clearable="false" v-model="data_local.type" :options="typeOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div>
          <p class="selectLabelNew">Forma preferencial de logística</p>
          <v-select :disabled="!enableFullUpdate" :clearable="false" v-model="data_local.logisticInfo" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
        </div>
        <div>
          <p class="selectLabelEnd">Operador logístico para esta conexão</p>
          <v-select :disabled="!enableFullUpdate" :clearable="true" v-model="data_local.logisticOperatorConnection" :options="data_local.logisticOperators" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
        </div>
        <div>
          <p class="selectLabelEnd">Aplicar checklist ao criar lote para minha conta</p>
          <v-select :clearable="true" v-model="data_local.checklistConnection" :options="data_local.checklists" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="updateConnection" :disabled="!validateForm">Atualizar dados</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="goToConnection">Cancelar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      options: [
        { id: 1, label: 'Coleta' },
        { id: 2, label: 'Entrega' }
      ],
      typeOptions: [
        { id: 1, label: 'Cliente' },
        { id: 2, label: 'Fornecedor' },
        { id: 3, label: 'Operador logístico' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    myCompanyId () { return JSON.parse(localStorage.getItem('userInfo')).Company.id },
    validateForm () { return !this.errors.any() },
    enableFullUpdate () {
      return this.data_local.createdByCompany === this.myCompanyId
    }
  },
  methods: {
    apiErrorMsg (msg) {
      if (msg === 'name') { return 'Nome deve ser informado' }
      if (msg === 'phone') { return 'Celular deve ser informado' }
      if (msg === 'users.phone') { return 'Celular já esta cadastrado' }
      if (msg === 'users.lotsEmail') { return 'Email já esta cadastrado' }
    },
    resendInvite () { console.log('resendInvite') },
    capitalize (str) { return str.slice(0, 1).toUpperCase() + str.slice(1, str.length) },
    async updateConnection () {
      if (!this.validateForm) return
      try {
        console.log(this.data_local)
        this.$vs.loading()
        await this.$http.put(
          `/api/v1/admin/company/connections/${this.data_local.id}`,
          {
            name: this.data_local.name,
            phone: this.data_local.phone,
            email: this.data_local.email,
            checklists: this.data_local.checklists,
            logisticInfo: this.data_local.logisticInfo.label ? this.data_local.logisticInfo.label : this.data_local.logisticInfo,
            type: this.data_local.type.label,
            logisticOperatorConnection: this.data_local.logisticOperatorConnection ? this.data_local.logisticOperatorConnection.id : null,
            checklistConnection: this.data_local.checklistConnection ? this.data_local.checklistConnection.id : null,
            couldCreateLot: this.data_local.couldCreateLot,
            couldCreateProcess: this.data_local.couldCreateProcess,
            couldReverseLogistic: this.data_local.couldReverseLogistic
          },
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Conexão atualizada',
          text: 'Atualização feita com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Erro na Atualização',
          text: this.apiErrorMsg(error.response.data.errors[0].path),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    goToConnection () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$router.push('/cadastro/conexoes/conexoes').catch(() => {})
    }
  }
}
</script>

<style>
.selectLabel {
  font-size: 12px;
  margin-top: 15px;
  margin-left: 5px;
}
.selectLabelNew {
  font-size: 12px;
  margin-top: 17px;
  margin-left: 5px;
}
.selectLabelEnd {
  font-size: 12px;
  margin-top: -4px;
  margin-left: 5px;
}
</style>
